import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./App.css";

import FeeReceiptUI from "./feeReciptUI";

const FeeReceipt = () => {
  const { transaction_id } = useParams();
  const location = useLocation(); // ✅ renamed to avoid ESLint conflict
  const admissionNumber = location.state?.admissionNumber;

  const [receiptData, setReceiptData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReceiptData = async () => {
      const token = sessionStorage.getItem("authToken");
      try {
        const decodedTransactionId = atob(transaction_id);
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/admin/getFeeReceipt/${decodedTransactionId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${token}`,
            },
            body: JSON.stringify({
              admissionNumber: admissionNumber,
            }),
          }
        );
        const result = await response.json();
        if (result.length > 0) {
          setReceiptData(result[0]);
        } else {
          setReceiptData(null);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching fee receipt:", error);
        setIsLoading(false);
      }
    };

    fetchReceiptData();
  }, [transaction_id]);

  return (
    <div>
      <FeeReceiptUI receiptData={receiptData} isLoading={isLoading} />
    </div>
  );
};

export default FeeReceipt;
